<template>
  <div class="appContainer">
    <v-row v-if="systemData">
      <v-col>
        <v-card class="noMarginCard">
          <v-card-title primary-title class="justify-center">System Info</v-card-title>
          <v-card-text>
            <v-simple-table v-if="systemData.sysInfo" class="sysInfo">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <v-icon>mdi-tag-text-outline</v-icon>
                    </td>
                    <td>{{ systemData.sysInfo.hostname }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-linux</v-icon>
                    </td>
                    <td>
                      {{
                        systemData.sysInfo.platform +
                        " " +
                        systemData.sysInfo.arch
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-timer-outline</v-icon>
                    </td>
                    <td>{{ systemData.sysInfo.uptime }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-btn @click="reloadDNS" fab x-small color="secondary">
                        <v-icon dark> mdi-refresh </v-icon>
                      </v-btn>
                    </td>
                    <td>Reload DNS</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="noMarginCard">
          <v-card-title primary-title class="justify-center">RAM</v-card-title>
          <v-card-text primary-title class="justify-center">
            <GChart class="gChart" :resizeDebounce="1000" :settings="{ packages: ['corechart', 'gauge'] }" type="Gauge"
              :data="[
                ['Label', 'Value'],
                ['%', systemData ? systemData.sysInfo.load.RAM.load : 0],
              ]" :options="{
  width: 200,
  height: 200,
  redFrom: 90,
  redTo: 100,
  yellowFrom: 75,
  yellowTo: 90,
  minorTicks: 5,
  align: 'center',
}" />
            <div class="chartLabel">
              {{
                (systemData.sysInfo.load.RAM.used / 1024 / 1024 / 1024).toFixed(
                  2
                )
              }}
              Gb /
              {{
                (
                  systemData.sysInfo.load.RAM.total /
                  1024 /
                  1024 /
                  1024
                ).toFixed(2)
              }}
              Gb
            </div>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-for="(cpu, index) in systemData.sysInfo.load.CPU" v-bind:key="index">
        <v-card class="noMarginCard">
          <v-card-title primary-title class="justify-center">CPU {{ index + 1 }}</v-card-title>

          <v-card-text primary-title class="justify-center">
            <GChart class="gChart" :resizeDebounce="1000" :settings="{ packages: ['corechart', 'gauge'] }" type="Gauge"
              :data="[
                ['Label', 'Value'],
                ['%', cpu.load],
              ]" :options="{
  width: 200,
  height: 200,
  redFrom: 90,
  redTo: 100,
  yellowFrom: 75,
  yellowTo: 90,
  minorTicks: 5,
  align: 'center',
}" />
            <div style="font-size: 12px" class="chartLabel">
              {{ cpu.model + " " + cpu.speed + " Mhz" }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="systemData">
      <v-col cols="12">
        <v-tabs v-model="tab" fixed-tabs background-color="primary" dark>
          <v-tab> Namespace </v-tab>
          <v-tab> Portali </v-tab>
          <v-tab> DNS </v-tab>
          <v-tab> Db Connections </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card class="noMarginCard" style="margin: 0px">
              <DataTables @restartNamespace="restartNamespace" @updateNamespace="updateNamespace"
                :headers="headers_namespace" :dense="true" :itemPerPage="5" :tableData="systemData.namespaces">
              </DataTables>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="noMarginCard" style="margin: 0px">
              <DataTables @apiDocs="apiDocs" :headers="headers_portal" :dense="true" :itemPerPage="5"
                :tableData="systemData.vHost"></DataTables>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="noMarginCard" style="margin: 0px">
              <DataTables @downloadCertDialog="downloadCertDialog" :headers="headers_dns" :dense="true" :itemPerPage="5"
                :tableData="systemData.DNS"></DataTables>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="noMarginCard" style="margin: 0px">
              <DataTables @killProcess="killProcess" :headers="headers_dbConn" :dense="true" :itemPerPage="5"
                :tableData="systemData.dbProcess"></DataTables>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-dialog max-width="600" v-model="dialogDownloadCert">
      <v-card>
        <v-toolbar color="primary" dark>DOWNLOAD CERTIFICATO </v-toolbar>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Subject</th>
                  <th>Scadenza</th>
                  <th>Visualizza</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="selectedItem && selectedItem.sslCert !== ''">
                  <td class="text-left">{{ selectedItem.subjectSSL }}</td>
                  <td class="text-left">
                    {{
                      new Date(selectedItem.expireSSL).toLocaleDateString("it")
                    }}
                  </td>
                  <td>
                    <v-btn icon color="green" @click="downloadCert('dns', 'showCert', 'crt')">
                      <v-icon>mdi-certificate-outline</v-icon>
                    </v-btn>
                    <v-btn icon color="green" @click="downloadCert('dns', 'showCert', 'key')">
                      <v-icon>mdi-key-chain</v-icon>
                    </v-btn>
                    <v-btn icon color="green" @click="downloadCert('dns', 'showCert', 'ca')">
                      <v-icon>mdi-file-sign</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-btn icon color="green" @click="downloadCert('dns', 'downloadCert', 'crt')">
                      <v-icon>mdi-certificate-outline</v-icon>
                    </v-btn>
                    <v-btn icon color="green" @click="downloadCert('dns', 'downloadCert', 'key')">
                      <v-icon>mdi-key-chain</v-icon>
                    </v-btn>
                    <v-btn icon color="green" @click="downloadCert('dns', 'downloadCert', 'ca')">
                      <v-icon>mdi-file-sign</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" @click="dialogDownloadCert = false">
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="600" v-model="dialogUpdateNamespace">
      <v-card>
        <v-toolbar color="primary" dark>AGGIORNAMENTO VERSIONE NAMESPACE
        </v-toolbar>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="text-left">Versione corrente</td>
                  <td class="text-left">
                    {{ selectedItem.version }}
                  </td>
                </tr>
                <tr>
                  <td class="text-left">Versione a cui aggiornare</td>
                  <td class="text-left">
                    <v-select v-model="selectedUpdateVersion" :items="updatePackages(selectedItem.version)"
                      :menu-props="{ maxHeight: '400' }" required color="primary" hint="Seleziona versione"
                      persistent-hint></v-select>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="yellow" @click="
            updateVersion(selectedItem.namespace, selectedUpdateVersion)
            ">
            <v-icon>mdi-package-variant-plus</v-icon>&nbsp;Aggiorna
          </v-btn>
          <v-btn color="green darken-1" @click="dialogUpdateNamespace = false">
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  components: { GChart, DataTables },
  name: "mgmt-console",
  data: () => ({
    drawer: false,
    dialogDownloadCert: false,
    dialogUpdateNamespace: false,
    selectedItem: null,
    selectedUpdateVersion: null,
    timer: null,
    tab: 0,
    group: null,
    systemData: null,
    headers_namespace: [
      { text: "status", value: "iconStatus", type: "icons" },
      { text: "namespace", value: "namespace", type: "text" },
      { text: "version", value: "version", type: "text" },
      { text: "database", value: "dbName", type: "text" },
      { text: "Ambiente", value: "iconAmbiente", type: "icons" },
      { text: "Spazio disco", value: "dbOccupation", type: "progressBar" },
      { text: "CPU", value: "pm2_cpu", type: "text" },
      { text: "RAM", value: "pm2_ram", type: "text" },
      { text: "Uptime", value: "pm2_uptime", type: "text" },
      { text: "Restart", value: "pm2_restart", type: "text" },
      { text: "portali attivi", value: "totCustId", type: "text" },
      { text: "Connessioni db", value: "dbConnections", type: "text" },
      { text: "Opzioni", value: "options", type: "buttons" },
    ],
    headers_portal: [
      { text: "namespace", value: "namespace", type: "text" },
      { text: "code", value: "code", type: "text" },
      { text: "type", value: "typeIcon", type: "icons" },
      { text: "hostname", value: "hostname", type: "link" },
      { text: "ragsoc", value: "ragsoc", type: "text" },
      { text: "refEmail", value: "refEmail", type: "text" },
      { text: "refNome", value: "refNome", type: "text" },
      { text: "refTel", value: "refTel", type: "text" },
      { text: "SSL Name", value: "sslName", type: "text" },
      { text: "SSL Expire", value: "sslExpire", type: "datetime" },
      { text: "Opzioni", value: "options", type: "buttons" },
    ],
    headers_dns: [
      { text: "dns", value: "dnsName", type: "text" },
      { text: "Stato", value: "iconStatus", type: "icons" },
      { text: "filtro namespace", value: "namespace", type: "text" },
      { text: "provider", value: "provider", type: "text" },
      { text: "CF Zone", value: "cfZoneId", type: "text" },
      { text: "SSL Expire", value: "expireSSL", type: "datetime" },
      { text: "Opzioni", value: "options", type: "buttons" },
    ],
    headers_dbConn: [
      { text: "PID", value: "ID", type: "text" },
      { text: "Stato", value: "iconStatus", type: "icons" },
      { text: "host", value: "iconHost", type: "icons" },
      { text: "time", value: "TIME", type: "text" },
      { text: "namespace", value: "namespace", type: "text" },
      { text: "Utente", value: "USER", type: "text" },
      { text: "Database", value: "DB", type: "text" },
      { text: "Opzioni", value: "options", type: "buttons" },
    ],
  }),
  computed: {
    refresh() {
      return this.$globalHandler.refresh.flag;
    },
  },
  watch: {
    refresh(flag) {
      this.loadData();
      this.$globalHandler.refresh.flag = false;
    },
    group() {
      this.drawer = false;
    },
  },
  methods: {
    updatePackages: function (curVersion) {
      if (!this.systemData) return false;
      return this.systemData.packageVersions
        .filter((el) => {
          return el !== curVersion;
        })
        .map((el) => {
          return { text: el, value: el };
        });
    },
    downloadCertDialog: function (item) {
      this.selectedItem = item;
      this.dialogDownloadCert = true;
    },
    downloadCert: function (type, func, cert) {
      window.open(
        window.location.origin +
        "/API/mgmt/" +
        func +
        "/" +
        type +
        "/" +
        this.selectedItem.dnsName +
        "/" +
        cert
      );
    },
    reloadDNS: async function () {
      let _ = this;
      let result = await Swal.fire({
        title: "Ricaricare i DNS ?",
        text: "Verranno ricaricati anche i certificati SSL",
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "SI",
        cancelButtonText: "NO",
        buttonsStyling: true,
      });
      if (result.value) {
        let response = await _.chiamataAxios("GET", "/mgmt/reloadDNS");
        if (response.msg.esito) _.loadData();
      }
    },
    updateVersion: async function (namespace, version) {
      let _ = this;
      if (!version || !_.systemData || !_.systemData.packageVersions.includes(version)) {
        Swal.fire({
          title: "Versione non valida",
          text: "Selezionare una versione a cui aggiornare",
          type: "warning",
        });
        return;
      }
      let result = await Swal.fire({
        title: "Aggiornare a " + version + " ?",
        text: "Assicurarsi prima che non ci siano problemi di retrocompatibilità con la nuova versione",
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "SI",
        cancelButtonText: "NO",
        buttonsStyling: true,
      });
      if (result.value) {
        let response = await _.chiamataAxios(
          "POST",
          "/mgmt/updateNamespaceVersion/" + namespace + "/" + version
        );
        Swal.fire({
          title: response.msg.esito
            ? "Aggiornamento lanciato"
            : "Errore aggiornamento",
          text: response.msg.msgTxt,
          type: response.msg.esito ? "success" : "warning",
        });
        if (response.msg.esito) _.dialogUpdateNamespace = false;
      }
    },
    killProcess: async function (item) {
      let _ = this;
      let result = await Swal.fire({
        title: "Killare il processo " + item.ID + "?",
        html:
          "<br>Status: " +
          item.COMMAND +
          "<br>namespace: " +
          item.namespace +
          "<br>uptime: " +
          item.TIME,
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "SI",
        cancelButtonText: "NO",
        buttonsStyling: true,
      });

      if (result.value) {
        let response = await _.chiamataAxios(
          "DELETE",
          "/mgmt/killProcess/" + item.ID
        );
        if (response.msg.esito) _.loadData();
      }
    },
    apiDocs: function (item) {
      window.open(item.swaggerUrl);
    },
    restartNamespace: async function (item) {
      let _ = this;
      let result = await Swal.fire({
        title: "Riavviare il namespace ?",
        text: "Se ci sono transazioni in sospeso andranno perse",
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "SI",
        cancelButtonText: "NO",
        buttonsStyling: true,
      });

      if (result.value) {
        let response = await _.chiamataAxios(
          "GET",
          "/mgmt/restartNamespace/" + item.namespace,
          { msg: "always" }
        );
        if (response.msg.esito) _.loadData();
      }
    },
    updateNamespace: function (item) {
      let _ = this;
      this.selectedItem = item;
      this.dialogUpdateNamespace = true;
    },
    loadData: async function () {
      let _ = this;
      let response = await _.chiamataAxios("GET", "/mgmt/getSystemDashboard");
      if (response.msg.esito) {
        _.systemData = response.data;
        _.systemData.namespaces = _.systemData.namespaces.map((namespace) => {
          namespace.iconAmbiente = [
            {
              icon: namespace.ifTest === 1 ? "mdi-test-tube" : "mdi-server",
              label: namespace.ifTest === 1 ? "Test" : "Prod",
              text:
                namespace.ifTest === 1
                  ? "Ambiente di test"
                  : "Ambiente di produzione",
              color: namespace.ifTest === 1 ? "yellow" : "green",
            },
          ];
          let statusColor = "green";
          let statusText = "Servizio attivo";
          let statusIcon = "mdi-check-circle";

          if (namespace.status && (!namespace.pm2 || namespace.pm2.status != "online")) {
            statusColor = "#b86500";
            statusIcon = "mdi-alert-circle";
            statusText = !namespace.pm2 || namespace.pm2.error
              ? "PM2 non trovato"
              : "PM2 " + namespace.pm2.status;
          }
          if (!namespace.status) {
            statusColor = "#8b0000";
            statusIcon = "mdi-close-circle";
            statusText = "Servizio offline";
          }
          namespace.iconStatus = [
            {
              icon: statusIcon,
              text: statusText,
              color: statusColor,
            },
          ];

          // Utilizzo disco
          namespace.dbOccupation = {
            value: (namespace.sizeDb * 100) / namespace.maxSizeDb,
            label: namespace.sizeDb + " / " + namespace.maxSizeDb,
          };

          namespace.pm2_cpu = "";
          namespace.pm2_ram = "";
          namespace.pm2_uptime = "";
          namespace.pm2_restart = "";
          namespace.options = [];
          if (namespace.pm2) {
            namespace.pm2_cpu = namespace.pm2.cpu + " %";
            namespace.pm2_ram = namespace.pm2.ram + " Mb";
            namespace.pm2_uptime = namespace.pm2.uptime;
            namespace.pm2_restart = namespace.pm2.restart_time;

            if (!namespace.pm2.error) {
              namespace.options = [
                {
                  icon: "mdi-reload",
                  color: "#b86500",
                  text: "Riavvia namespace",
                  function: "restartNamespace",
                },
                {
                  icon: "mdi-package-variant-plus",
                  color: "yellow",
                  text: "Aggiorna versione namespace",
                  function: "updateNamespace",
                },
              ];
            }
          }
          return namespace;
        });

        _.systemData.DNS = _.systemData.DNS.map((DNS) => {
          DNS.iconStatus = [
            {
              icon: DNS.enabled === 1 ? "mdi-check-circle" : "mdi-close-circle",
              text: DNS.enabled === 1 ? "Attivo" : "Spento",
              color: DNS.enabled === 1 ? "green" : "red",
            },
          ];
          DNS.options = [
            {
              icon: "mdi-certificate-outline",
              color: "green",
              text: "Download Certificati",
              function: "downloadCertDialog",
            },
          ];
          return DNS;
        });
        _.systemData.dbProcess = _.systemData.dbProcess.map((process) => {
          process.iconStatus = [
            {
              icon:
                process.COMMAND === "Sleep" ? "mdi-sleep" : "mdi-check-circle",
              label: process.COMMAND,
              color: process.COMMAND === "Sleep" ? "yellow" : "green",
            },
          ];
          process.iconHost = [
            {
              icon: process.HOST.includes("localhost")
                ? "mdi-shield-home-outline"
                : "mdi-web",
              label: process.HOST,
              color: process.HOST.includes("localhost") ? "green" : "yellow",
            },
          ];
          process.options = [
            {
              icon: "mdi-close",
              color: "error",
              text: "Kill processo",
              function: "killProcess",
            },
          ];
          return process;
        });

        _.systemData.vHost = _.systemData.vHost.map((vHost) => {
          vHost.typeIcon = [
            {
              icon:
                vHost.ifEnte === 1
                  ? "mdi-hexagon-multiple-outline"
                  : "mdi-bank",
              label: vHost.ifEnte === 1 ? "Ente" : "Asd",
              text: vHost.ifEnte === 1 ? "Ente" : "Asd",
              color: vHost.ifEnte === 1 ? "primary" : "green",
            },
          ];
          vHost.hostname = {
            url: vHost.fullUrl,
            text: vHost.hostname,
          };
          vHost.sslName = vHost.SSL ? vHost.SSL.subjectSSL : "";
          vHost.sslExpire = vHost.SSL ? vHost.SSL.expireSSL : "";
          vHost.options = [];
          if (vHost.swaggerUrl && vHost.swaggerUrl !== "") {
            vHost.options.push({
              icon: "mdi-xml",
              color: "primary",
              text: "API Docs",
              function: "apiDocs",
            });
          }
          return vHost;
        });
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  },
  mounted() {
    this.loadData();
    this.timer = setInterval(this.loadData, 1000 * 60);
  },
};
</script>

<style type="text/css">
.gChart table {
  margin: auto !important;
}

.appContainer {
  margin: 10px 20px;
}

.chartLabel {
  text-align: center;
}

.sysInfo td {
  font-size: 12px !important;
}

.noMarginCard {
  margin-top: 0px !important;
  height: 100%;
  overflow: auto !important;
}
</style>